import { FC } from 'react';

import { Stack } from '@mui/material';
import { AcademicYearTitle } from 'components/pdfStudent';
import { splitDataWithUnformattedEventDate } from 'containers/pdfStudent/utils';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetProfessionProforientationEvents } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { proforientationModel } from 'portfolio3/features/proforientation';
import { getDataLoadRequests } from 'utils';

import PdfCommonDataEntityContainer from '../common';
import EventExcursionsSection from './proforientation/EventExcursionsSection';
import EventOpenDaySection from './proforientation/EventOpenDaySection';
import EventProbesSection from './proforientation/EventProbesSection';

import '../index.scss';

const PdfProforientationEvents: FC = () => {
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().professionProforientation });

  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const probes = useAppSelector(proforientationModel.selectors.proforientationEventSelectors.probes);
  const excursions = useAppSelector(proforientationModel.selectors.proforientationEventSelectors.excursions);
  const dods = useAppSelector(proforientationModel.selectors.proforientationEventSelectors.dods);

  const hasData = excursions.length !== 0 || dods.length !== 0 || probes.length !== 0;

  const excursionsAcademicYearData = splitDataWithUnformattedEventDate(excursions, academicYears);
  const probesAcademicYearData = splitDataWithUnformattedEventDate(probes, academicYears);
  const dodsAcademicYearData = splitDataWithUnformattedEventDate(dods, academicYears);

  const yearsList = new Set([
    ...excursionsAcademicYearData.map(([year, _]) => year),
    ...probesAcademicYearData.map(([year, _]) => year),
    ...dodsAcademicYearData.map(([year, _]) => year),
  ]);

  return (
    <PdfCommonDataEntityContainer
      title="Профориентационные мероприятия"
      Icon={IconWidgetProfessionProforientationEvents}
    >
      {hasData &&
        Array.from(yearsList).map((academicYear) => {
          const excursionsData = excursionsAcademicYearData.find(([year, _]) => year === academicYear);
          const probesData = probesAcademicYearData.find(([year, _]) => year === academicYear);
          const dodsData = dodsAcademicYearData.find(([year, _]) => year === academicYear);

          if (!excursionsData && !probesData && !dodsData) {
            return null;
          }

          return (
            <div key={academicYear}>
              <AcademicYearTitle academicYear={academicYear} />
              <Stack gap="16px">
                {probesData && <EventProbesSection data={probesData[1]} />}
                {excursionsData && <EventExcursionsSection data={excursionsData[1]} />}
                {dodsData && <EventOpenDaySection data={dodsData[1]} />}
              </Stack>
            </div>
          );
        })}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfProforientationEvents;
